@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ title }}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<!-- COMPANY & DELEGATION-->
			<div class="row justify-content-start mt-3">
				<div class="col-sm-6">
					<form-input
						[required]="false"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.companies.company' | translate }}"
					>
						<p-select
							[options]="billingAccountList"
							[(ngModel)]="entity.company"
							placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.companies.company' | translate }}"
							dataKey="id"
							optionLabel="fullName"
							[style]="{ width: '100%' }"
							appendTo="body"
							[filter]="true"
							(onChange)="onChangeBillingAccount($event)"
							(onFilter)="onFilterBillingAccount($event)"
						>
						</p-select>
					</form-input>
				</div>
				<div class="col-sm-6">
					<form-input
						[required]="false"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.delegations.delegation' | translate }}"
					>
						<p-select
							[options]="delegationList"
							[(ngModel)]="entity.delegation"
							placeholder="{{ 'general.select' | translate }} {{
								'tableManagement.delegations.delegation' | translate
							}}"
							dataKey="id"
							[style]="{ width: '100%' }"
							appendTo="body"
							optionLabel="fullName"
							[filter]="true"
							(onChange)="onChangeDelegation($event)"
							(onFilter)="onFilterDelegation($event)"
						>
						</p-select>
					</form-input>
				</div>
			</div>
			<!-- SUBDELEGATION & CECO-->
			<div class="row justify-content-start mt-3">
				<div class="col-sm-6">
					<form-input
						[required]="false"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.subdelegations.subdelegation' | translate }}"
					>
						<p-select
							[options]="subDelegationList"
							[(ngModel)]="entity.subDelegation"
							placeholder="{{ 'general.select' | translate }} {{
								'tableManagement.subdelegations.subdelegation' | translate
							}}"
							dataKey="id"
							[style]="{ width: '100%' }"
							appendTo="body"
							[filter]="true"
							optionLabel="fullName"
							(onChange)="onChangeSubDelegation($event)"
							(onFilter)="onFilterSubDelegation($event)"
						>
						</p-select>
					</form-input>
				</div>
				<div class="col-sm-6">
					<form-input
						[required]="false"
						[align]="'stacked'"
						fieldName="{{ 'drivers.table.ceco' | translate }}"
					>
						<p-select
							[options]="cecoList"
							[(ngModel)]="entity.ceco"
							placeholder="{{ 'general.select' | translate }} {{ 'drivers.table.ceco' | translate }}"
							dataKey="id"
							[style]="{ width: '100%' }"
							appendTo="body"
							[filter]="true"
							optionLabel="fullName"
							(onChange)="onChangeCeco($event)"
							(onFilter)="onFilterCeco($event)"
						>
						</p-select>
					</form-input>
				</div>
			</div>
			<!-- START DATE & END DATE -->
			<div class="row justify-content-start mt-3">
				<div class="col-sm-6">
					<form-input
						[required]="true"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.cardLists.assignDateShort' | translate }}"
					>
						<p-datepicker
							[(ngModel)]="startDate"
							[showTime]="false"
							[style]="{ width: '100%' }"
							dateFormat="{{ i18n.dateFormat }}"
							showIcon="true"
							appendTo="body"
							[firstDayOfWeek]="1"
							[minDate]="minStartDate"
							[maxDate]="maxStartDate"
						></p-datepicker>
					</form-input>
				</div>
				<div class="col-sm-6">
					<form-input
						[required]="false"
						[align]="'stacked'"
						fieldName="{{ 'tableManagement.cardLists.deassignDateShort' | translate }}"
					>
						<p-datepicker
							[(ngModel)]="endDate"
							[showTime]="false"
							[style]="{ width: '100%' }"
							dateFormat="{{ i18n.dateFormat }}"
							showIcon="true"
							appendTo="body"
							[firstDayOfWeek]="1"
						></p-datepicker>
					</form-input>
				</div>
			</div>
			<!-- DOCUMENTS -->
			@if (!isNew) {
				<div class="row mt-3">
					<app-doc-table
						type="vehicle_assignment"
						[entity]="entity"
						[nested]="true"
						[ids]="ids"
						(return)="refresh()"
					>
					</app-doc-table>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center bd-highlight">
				<div class="p-2 bd-highlight">
					@if (!isNew) {
						<div>
							<button class="btn custom-button" (click)="save()" [disabled]="!canUpdate" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
